import { Box, Button, Typography, Stack, LinearProgress, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { APPLICATION_STATUS, APPLICATION_SUB_STATUS_EMBA } from '../../../Utils/Constants/constant';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getApplicationPreviewPdf } from '../../../Utils/apiServices';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import KenLoader from '../../KenLoader';
import { programs } from '../../../Utils/Constants/CourseDetails';
import noImage from '../../../Assets/Images/no-image.png';
import AccessTimeFilledOutlinedIcon from '@mui/icons-material/AccessTimeFilledOutlined';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { downloadFile } from '../../../Utils/Helpers/applicationHelper';

import { useZoomLevel } from '../../UseZoomLevel';
const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    background: '#F6F8FB',
    borderRadius: '0.25rem',
    padding: '1rem',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
  },
  banner:(props)=>( {
    height:props?.isZoomedOut?'10vh': '12vh',
    width: '100%',
    borderRadius: '0.30rem',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.down('md')]: {
      height: '18vh',
    },
  }),
  title:(props)=>( {
    fontSize: '1rem',
    lineHeight: '1.1rem',
    color:'rgba(88, 90, 100, 1)',
    fontWeight: '600',
    '@media (max-width: 1440px)': {
      fontSize:'1rem',
    },
    [theme.breakpoints.down('md')]: {
      fontWeight: '600',
    },
  }),
  lastDateLable: {
    color: '#32501F',
    fontSize: '0.75rem',
    fontWeight: '500',
    lineHeight: '0.8rem',
    marginBottom: '0.4rem',
    fontFamily: "'Nunito', sans-serif",
    '@media (max-width: 1440px)': {
      fontSize: '0.65rem',
      lineHeight: '0.8rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.75rem',
      fontWeight: 600,
    },
  },
  percent: {
    color: '#000000',
    fontSize: '0.75rem',
    fontWeight: '600',
    fontFamily: "'Nunito', sans-serif",
    lineHeight: '0.7rem',
    '@media (max-width: 1440px)': {
      fontSize: '0.7rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
      fontWeight: 600,
    },
  },
  downloadIcon: {
    color: '#F6F8FB',
    fontSize: '1.2rem',
    '@media (max-width: 1440px)': {
      fontSize: '1rem',
    },
  },
  status: {
    color: 'rgba(71, 113, 43, 1)',
    fontSize: '0.75rem',
    fontWeight: '800',
    fontFamily: "'Nunito', sans-serif",
    lineHeight: '0.9rem',
    '@media (max-width: 1440px)': {
      fontSize: '0.75rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
      fontWeight: 600,
    },
  },
  btn: {
    background: 'linear-gradient(270deg, #FFEB42 -442.77%, #47712B 100%)',
    color: 'white',
    borderRadius: '0.3rem',
    fontWeight: '500',
    fontSize: '0.7rem',
    textTransform: 'none',
    textWrap: 'nowrap',
    padding: '0.3rem 0.8rem',
    '@media (max-width: 1440px)': {
      fontSize: '0.65rem',
      padding: '0.2rem 0.7rem',
      borderRadius: '0.2rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.75rem',
      padding: '0.4rem 1rem',
    },
  },
  prefernceText: {
    fontSize: '0.8rem',
    fontWeight: '400',
    fontFamily: "'Nunito', sans-serif",
    fontStyle: 'italic',
  },
  dateValue: {
    color: '#32501F',
    fontSize: '0.7rem',
    fontWeight: '600',
    fontFamily: "'Nunito', sans-serif",
    '@media (max-width: 1440px)': {
      fontSize: '0.65rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.75rem',
    },
  },
  cycleTag: {
    background: '#FFF280',
    fontSize: '0.75rem',
    color: '#6B631C',
    height: 'fit-content',
    fontWeight: '600',
    fontFamily: "'Nunito', sans-serif",
    padding: '0rem 0.9rem',
    borderRadius: '0rem 0.30rem 0rem 0.5rem',
    '@media (max-width: 1440px)': {
      fontSize: '0.6rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
    },
  },
  statusTag: {
    fontSize: '0.7rem',
  },
  divider: {
    height: '1px',
    background: '#B2B3B7',
    marginBottom: '0.4rem',
    width: '100%',
  },
  tagIcons: {
    color: '#695113',
    fontSize: '0.6rem',
    '@media (max-width: 1440px)': {
      fontSize: '0.5rem',
    },
  },
  tagText1: {
    fontSize: '0.6rem',
    color: '#695113',
    fontWeight: '500',
    '@media (max-width: 1440px)': {
      fontSize: '0.5rem',
    },
  },
  tag1: {
    background: '#FEEBBE',
    borderRadius: '50px',
    padding: '0.3rem 0.6rem',
    width: 'max-content',
    '@media (max-width: 1440px)': {
      padding: '0.2rem 0.4rem',
    },
  },
  tagText2: {
    fontSize: '0.76rem',
    color: 'rgba(30, 30, 30, 1)',
    fontWeight: '600',
    fontFamily: 'Lato',
    '@media (max-width: 1440px)': {
      fontSize: '0.75rem',
    },
  },
  tag2: {
    background: 'rgba(226, 226, 226, 1)',
    borderRadius: '50px',
    padding: '0.5rem 1rem',
    width: 'max-content',
    fontFamily: 'Lato',
    '@media (max-width: 1440px)': {
      padding: '0.5rem 1rem',
    },
  },
  booking: {
    fontSize: '0.875rem',
    color: 'rgba(100, 100, 100, 1)',
    fontWeight:'700'
  },
  appNoTitle: {
    fontSize: '0.75rem',
    fontWeight: '500',
    lineHeight: '1.5rem',
    fontFamily: "'Nunito', sans-serif",
    borderBottom:'1px solid rgba(223, 223, 223, 1)',
    padding:'0 0 0.5rem 0',
    marginBottom:'0.5rem',
    '@media (max-width: 1440px)': {
      fontSize: '0.75rem',
    },
    [theme.breakpoints.down('md')]: {
      fontWeight: '600',
    },
  },
}));

export default function ApplicationCard(props) {
  const { item, goToApplicationForm, home } = props;
  const zoomLevel = useZoomLevel();
  const isZoomedOut = zoomLevel >= 150;
  const classes = useStyles({isZoomedOut,home});
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const bannerImage =
    programs.find((items) => {
      return items.courseValue === item?.programName;
    })?.image || noImage;
  const applicationStatus = (parseInt(item?.Current_Step__c) / 9) * 100;

  const handleDownloadPdf = async (appId) => {
    try {
      setLoading(true);
      const res = await getApplicationPreviewPdf(appId);
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);
      setLoading(false);
      downloadFile(pdfUrl, `${item?.Application_Number__c}.pdf`);
    } catch (err) {
      setLoading(false);
      console.error(err);
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    }
  };

  const handleCardAction = () => {
    // Scenario 1: Application not yet initiated
    if (item?.hed__Application_Status__c) {
      // Case 1.1: Application start date/time is in the future (before window opens)
      if (moment(item?.startDate).isAfter(moment(), 'minutes')) {
        return (
          <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
            <Stack direction={'column'} alignItems={'start'}>
              <Typography className={classes.status}>Opening on</Typography>
              <Typography className={classes.dateValue}>{moment(item?.startDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
            </Stack>
          </Stack>
        );
        // Case 1.2: Application is open (start date/time passed, end date/time in future)
      } else if (moment(item?.endDate).isAfter(moment(), 'minutes')) {
        return (
          <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={isZoomedOut?'0.3rem':'0.6rem'} width={'100%'}>
            <Stack direction={'column'} alignItems={'start'}>
              <Typography className={classes.status}>Interview Slots Open</Typography>
              {/* <Typography className={classes.dateValue}>{moment(item?.endDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography> */}
            </Stack>
            <Button
              className={classes.btn}
              variant="contained"
              onClick={(e) => {
                goToApplicationForm(item);
              }}
            >
              Book Slot
            </Button>
          </Stack>
        );
        // Case 1.3: Application window closed (end date/time passed)
      } else {
        return (
          <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
            <Stack direction={'column'} alignItems={'start'}>
              <Typography className={classes.status}>Application window closed on</Typography>
              <Typography className={classes.dateValue}>{moment(item?.endDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
            </Stack>
          </Stack>
        );
      }
      // Scenario 2: Application is either "Application Initiated" or "Application Submitted"
    } else if (item?.hed__Application_Status__c === APPLICATION_STATUS[0] || item?.hed__Application_Status__c === APPLICATION_STATUS[1]) {
      // Sub-scenario 2.1: Status = "Application Submitted"
      if (item?.hed__Application_Status__c === APPLICATION_STATUS[1]) {
        // Case 2.1.1: Payment submission date/time has already passed (payment window closed)
        if (moment(item?.paymentSubmissionDate).isBefore(moment(), 'minutes')) {
          return (
            <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
              <Stack direction={'column'} alignItems={'start'}>
                <Typography className={classes.status}>Payment window closed on</Typography>
                <Typography className={classes.dateValue}>{moment(item?.paymentSubmissionDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
              </Stack>
            </Stack>
          );
          // Case 2.1.2: Payment still open (either before payment deadline or before application end date/time)
        } else {
          return (
            <Stack direction={'column'} gap={'3px'} marginTop={'0.6rem'} width={'100%'}>
              {moment(item?.endDate).isAfter(moment(), 'minutes') ? (
                <Typography className={classes.lastDateLable}>Last Date to Apply: {moment(item?.endDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
              ) : (
                <Typography className={classes.lastDateLable}>Last Date for Payment: {moment(item?.paymentSubmissionDate).format('DD-MM-YYYY HH:MM')}</Typography>
              )}
              <LinearProgress variant="buffer" value={applicationStatus} />
              <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'6px'}>
                <Stack direction={'column'} alignItems={'start'}>
                  <Typography className={classes.percent}>{Math.round(applicationStatus)}%</Typography>
                  <Typography className={classes.status}>Application Process</Typography>
                </Stack>
                <Button
                  className={classes.btn}
                  variant="contained"
                  onClick={(e) => {
                    goToApplicationForm(item);
                  }}
                >
                  Pay Now
                </Button>
              </Stack>
            </Stack>
          );
        }
        // Sub-scenario 2.2: Status = "Application Initiated"
      } else {
        // Case 2.2.1: Application end date/time still in future (can resume application)
        if (moment(item?.endDate).isAfter(moment(), 'minutes')) {
          return (
            <Stack direction={'column'} gap={'3px'} marginTop={'0.1rem'} width={'100%'}>
              <Typography className={classes.lastDateLable}>Last Date for Submission: {moment(item?.endDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
              <LinearProgress variant="buffer" value={applicationStatus} />
              <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'6px'}>
                <Stack direction={'column'} alignItems={'start'}>
                  <Typography className={classes.percent}>{Math.round(applicationStatus)}%</Typography>
                  <Typography className={classes.status}>Application Process</Typography>
                </Stack>
                <Button
                  className={classes.btn}
                  variant="contained"
                  onClick={(e) => {
                    goToApplicationForm(item);
                  }}
                >
                  Resume
                </Button>
              </Stack>
            </Stack>
          );
          // Case 2.2.2: Application window closed (end date/time passed)
        } else {
          return (
            <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
              <Stack direction={'column'} alignItems={'start'}>
                <Typography className={classes.status}>Application window closed on</Typography>
                <Typography className={classes.dateValue}>{moment(item?.endDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
              </Stack>
            </Stack>
          );
        }
      }
      // Scenario 3: Application is beyond "Application Submitted" (e.g., payment done, documents screened, etc.)
    } else {
      // For EMBA Stage 2 need to follow Sub_Status after application fee paid
      if (item?.programNameShort === 'EMBA') {
        if (item?.Sub_Status__c === APPLICATION_SUB_STATUS_EMBA[0]) {
          if (moment(item?.endDateStage2).isAfter(moment(), 'day')) {
            return (
              <Stack direction={'column'} gap={'3px'} marginTop={'0.1rem'} width={'100%'}>
                <Typography className={classes.lastDateLable}>Last Date for Submission: {moment(item?.endDateStage2, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
                <LinearProgress variant="buffer" value={applicationStatus} />
                <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'6px'}>
                  <Stack direction={'column'} alignItems={'start'}>
                    <Typography className={classes.percent}>{Math.round(applicationStatus)}%</Typography>
                    <Typography className={classes.status}>Application Process</Typography>
                  </Stack>
                  <Button
                    className={classes.btn}
                    variant="contained"
                    onClick={(e) => {
                      goToApplicationForm(item);
                    }}
                  >
                    Resume
                  </Button>
                </Stack>
              </Stack>
            );
          } else {
            return (
              <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
                <Stack direction={'column'} alignItems={'start'}>
                  <Typography className={classes.status}>Application window closed on</Typography>
                  <Typography className={classes.dateValue}>{moment(item?.endDateStage2, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
                </Stack>
              </Stack>
            );
          }
        } else if (item?.Sub_Status__c === APPLICATION_SUB_STATUS_EMBA[1]) {
          return (
            <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
              <Stack direction={'column'} alignItems={'start'}>
                <Typography className={classes.dateValue}>Application under review</Typography>
              </Stack>
            </Stack>
          );
        } else {
          return (
            <Stack direction={'column'} gap={'16px'} marginTop={'0.7rem'} width={'100%'}>
              <Divider />
              <Stack direction={'column'} justifyContent={'space-between'} alignItems={'center'} gap={'0.7rem'}>
                {item?.Awaited_Submission_Steps__c ? (
                  <Button
                    className={classes.btn}
                    fullWidth
                    variant="contained"
                    onClick={() => {
                      goToApplicationForm(item);
                    }}
                  >
                    Update Qualifying Test Details
                  </Button>
                ) : null}
                <Button
                  className={classes.btn}
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    handleDownloadPdf(item?.Id);
                  }}
                >
                  Download PDF <FileDownloadOutlinedIcon className={classes.downloadIcon} />
                </Button>
              </Stack>
            </Stack>
          );
        }
      } else {
        // For EMBA Stage 2 need to follow Sub_Status after application fee paid
      if (item?.programNameShort === 'EMBA') {
        if (item?.Sub_Status__c === APPLICATION_SUB_STATUS_EMBA[0]) {
          if (moment(item?.endDateStage2).isAfter(moment(), 'day')) {
            return (
              <Stack direction={'column'} gap={'3px'} marginTop={'0.1rem'} width={'100%'}>
                <Typography className={classes.lastDateLable}>Last Date for Submission: {moment(item?.endDateStage2, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
                <LinearProgress variant="buffer" value={applicationStatus} />
                <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'6px'}>
                  <Stack direction={'column'} alignItems={'start'}>
                    <Typography className={classes.percent}>{Math.round(applicationStatus)}%</Typography>
                    <Typography className={classes.status}>Application Process</Typography>
                  </Stack>
                  <Button
                    className={classes.btn}
                    variant="contained"
                    onClick={(e) => {
                      goToApplicationForm(item);
                    }}
                  >
                    Resume
                  </Button>
                </Stack>
              </Stack>
            );
          } else {
            return (
              <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
                <Stack direction={'column'} alignItems={'start'}>
                  <Typography className={classes.status}>Application window closed on</Typography>
                  <Typography className={classes.dateValue}>{moment(item?.endDateStage2, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY | hh:mm A')}</Typography>
                </Stack>
              </Stack>
            );
          }
        } else if (item?.Sub_Status__c === APPLICATION_SUB_STATUS_EMBA[1]) {
          return (
            <Stack direction={'row'} justifyContent={'space-between'} gap={'6px'} alignItems={'center'} borderTop={'1px solid #B2B3B7'} paddingTop={'4px'} marginTop={'0.6rem'} width={'100%'}>
              <Stack direction={'column'} alignItems={'start'}>
                <Typography className={classes.dateValue}>Application not qualified</Typography>
              </Stack>
            </Stack>
          );
        } else {
          return (
            <Stack direction={'column'} gap={'16px'} marginTop={'0.7rem'} width={'100%'}>
              <Divider />
              <Stack direction={'column'} justifyContent={'space-between'} alignItems={'center'} gap={'0.7rem'}>
                {item?.Awaited_Submission_Steps__c ? (
                  <Button
                    className={classes.btn}
                    fullWidth
                    variant="contained"
                    onClick={() => {
                      goToApplicationForm(item);
                    }}
                  >
                    Update Qualifying Test Details
                  </Button>
                ) : null}
                <Button
                  className={classes.btn}
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    handleDownloadPdf(item?.Id);
                  }}
                >
                  Download PDF <FileDownloadOutlinedIcon className={classes.downloadIcon} />
                </Button>
              </Stack>
            </Stack>
          );
        }
      } else {
        return (
          <Stack direction={'column'} gap={'16px'} marginTop={'0.7rem'} width={'100%'}>
            <Divider />
            <Stack direction={'column'} justifyContent={'space-between'} alignItems={'center'} gap={'0.7rem'}>
              {item?.Awaited_Submission_Steps__c ? (
                <Button
                  className={classes.btn}
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    goToApplicationForm(item);
                  }}
                >
                  Update Qualifying Test Details
                </Button>
              ) : null}
              <Button
                className={classes.btn}
                fullWidth
                variant="contained"
                onClick={() => {
                  handleDownloadPdf(item?.Id);
                }}
              >
                Download PDF <FileDownloadOutlinedIcon className={classes.downloadIcon} />
              </Button>
            </Stack>
          </Stack>
        );
      }
      }
    }
  };

  function formatEndDate(s) {
    if (!s) return "";
    // Parse safely (works across browsers)
    const [datePart, timePart] = s.split(" ");
    const [y, m, d] = datePart.split("-").map(Number);
    const [hh, mm] = timePart.split(":").map(Number);
  
    const dt = new Date(y, m - 1, d, hh, mm);
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];
  
    const dd = String(dt.getDate()).padStart(2, "0");
    const monthStr = months[dt.getMonth()];
    let hours = dt.getHours() % 12 || 12;
    const mins = String(dt.getMinutes()).padStart(2, "0");
    const ampm = dt.getHours() >= 12 ? "PM" : "AM";
  
    return `${dd}-${monthStr}-${dt.getFullYear()}, ${hours}:${mins} ${ampm}`;
  }

  const handleStatusTag = () => {
    if (item?.hed__Application_Status__c) {
      // if (moment(item?.endDate).isAfter(moment(), 'day')) {
      //   return null;
      // } else {
      //   return (
      //     <Stack direction={'row'} alignItems={'center'} gap={'0.3rem'} className={classes.tag2}>
      //       <ErrorOutlinedIcon className={classes.tagIcons} />
      //       <Typography className={classes.tagText2}>Form Closed</Typography>
      //     </Stack>
      //   );
      // }
      return (
        <>
          <Stack direction={'row'} alignItems={'center'} gap={'0.3rem'} className={classes.tag2}>
            {/* <ErrorOutlinedIcon className={classes.tagIcons} /> */}
            <Typography className={classes.tagText2}>Round 1</Typography>
          </Stack>
          <Box className={classes.booking}>
            <i><Stack direction={'row'} alignItems={'center'} gap={'0.3rem'}>
              <Typography>Book Before:  </Typography>
              <Typography>{formatEndDate(item?.endDate)}</Typography>
            </Stack></i>
          </Box>
        </>
      );
    } else if (item?.hed__Application_Status__c === APPLICATION_STATUS[0] || item?.hed__Application_Status__c === APPLICATION_STATUS[1]) {
      if (item?.hed__Application_Status__c === APPLICATION_STATUS[1]) {
        if (moment(item?.paymentSubmissionDate).isBefore(moment(), 'hour')) {
          return (
            <Stack direction={'row'} alignItems={'center'} gap={'0.3rem'} className={classes.tag1}>
              <AccessTimeFilledOutlinedIcon className={classes.tagIcons} />
              <Typography className={classes.tagText1}>Payment Date Lapsed</Typography>
            </Stack>
          );
        } else {
          return null;
        }
      } else {
        if (moment(item?.endDate).isAfter(moment(), 'day')) {
          return null;
        } else {
          return (
            <Stack direction={'row'} alignItems={'center'} gap={'0.3rem'} className={classes.tag2}>
              <ErrorOutlinedIcon className={classes.tagIcons} />
              <Typography className={classes.tagText2}>Form Closed</Typography>
            </Stack>
          );
        }
      }
    } else {
      return null;
    }
  };

  return (
    <>
      {loading && <KenLoader />}
      <div className={classes.container} style={{ height: home ? '95%' : '100%' }}>
      {item?.Application_Number__c && <Typography className={classes.appNoTitle}>Application Number:<span style={{ color: "rgba(71, 113, 43, 1)",fontWeight:'800' }}> #{item?.Application_Number__c}</span></Typography>}
        <Stack direction={'column'} alignItems={'center'} justifyContent={'space-between'} height={'100%'}>
          <Stack direction={'column'} gap='1rem' pb={isZoomedOut?0:0.5} width={'100%'}>
            {/* <Box component={'div'} className={classes.banner} sx={{ backgroundImage: `url(${bannerImage})` }}>
              <Typography className={classes.cycleTag}>{item?.academicCycle}</Typography>
            </Box> */}
            <Stack direction={'column'} gap={isZoomedOut?'0.3rem':'0.4rem'}>
              <Typography className={classes.title}>{item?.applicationFormName}</Typography>
            </Stack>
            {handleStatusTag()}
          </Stack>
          {handleCardAction()}
        </Stack>
      </div>
    </>
  );
}
